import {
  AutoComplete,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  notification,
  Row,
  Select,
  Tooltip,
} from "antd";
import FormInput from "components/FormInput/FormInput";
import React, { useEffect, useState } from "react";
import { ReactComponent as IconSave } from "../../../assets/images/right-border.svg";
import { ReactComponent as IconRemove } from "../../../assets/images/fail.svg";
import { ReactComponent as IconAdd } from "../../../assets/images/add_round.svg";
import { numberWithCommas } from "shared/services/Utility";
import { FormInstance } from "antd/es/form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import API_SERVICE from "shared/services/api-service";
import AppLoading from "shared/components/AppLoading/AppLoading";
import { debounce } from "lodash";
import "./PayoutInvoices.scss";
import { margin, padding } from "polished";
import { setIsInvoiceEmpPending } from "shared/redux/common-reducer";

interface IPayoutInvoicesRow {
  invoice: any;
  columns: any;
  selectedInvoices: string[];
  setSelectedInvoices: React.Dispatch<React.SetStateAction<string[]>>;
  formInvoice: FormInstance<any>;
  callbackUpdateInvoice: () => void;
}

const PayoutInvoicesRow: React.FunctionComponent<IPayoutInvoicesRow> = (
  props: IPayoutInvoicesRow
) => {
  const {
    invoice,
    columns,
    selectedInvoices,
    setSelectedInvoices,
    formInvoice,
    callbackUpdateInvoice,
  } = props;

  const [status, setStatus] = useState(null as any);
  const [showDetail, setShowDetail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [assignToData, setAssignToData] = useState([] as any);
  const [employeeDetails, setEmployeeDetails] = useState([] as any);
  const [showEmployeePayoutModal, setShowEmployeePayoutModal] = useState(false);
  const [showEmployeeWarningModal, setShowEmployeeWarningModal] = useState(false);
  const { appColors, isInvoiceEmpPending }: any = useSelector((state: RootState) => state.common);
  const dispatch = useDispatch();

  const [formInvoiceRow] = Form.useForm() as any;
  const [formEmployee] = Form.useForm() as any;

  const checked = selectedInvoices?.some(
    (item: any) => item == invoice?.invoiceId
  );

  useEffect(() => {
    setEmployeeFields(invoice?.employeePayoutDetailsDtoList);
  }, []);

  const setEmployeeFields = (tmpList: any) => {
    let filedsValues = {} as any;
    const tmpEmployeesDetail = tmpList?.map((item, index) => {
      const amount = item?.monetaryDetails?.netPayoutAmount ?? item?.payoutAmount
      const tmp = {
        [`userId${index}`]: item.userId,
        [`userName${index}`]: item.userName,
        [`amount${index}`]: amount,
      }
      filedsValues = { ...filedsValues, ...tmp }
      return {
        "userId": item.userId,
        "userName": item.userName,
        payoutAmount: amount,
        saved: item.saved ?? Object.keys(item?.monetaryDetails ?? {}).length > 0
      }
    })
    formEmployee.resetFields()
    if ((tmpEmployeesDetail?.length ?? 0) == 0) {
      setEmployeeDetails([{}]);
    } else {
      setEmployeeDetails(tmpEmployeesDetail);
      formEmployee.setFieldsValue(filedsValues)
    }
  }

  useEffect(() => {
    if (!checked) {
      setStatus(null);
      formInvoice.resetFields([
        `status${invoice.invoiceId}`,
        `date${invoice.invoiceId}`,
        `amount${invoice.invoiceId}`,
        `UTRNumber${invoice.invoiceId}`,
        `comment${invoice.invoiceId}`,
      ]);
    }
  }, [checked]);

  const callback = (data) => {
    if (data == "APPROVED") {
      setShowEmployeePayoutModal(true)
    }
    setShowDetail(true);
    setStatus(data);
  };

  const searchAssignTo = (ev: any) => {
    const params = {
      name: ev,
    };
    API_SERVICE.getUsersWithRole(params).then(({ data }) => {
      if (data) {
        setAssignToData(data.payload);
      }
    });
  };

  const updateInvoice = (values) => {
    if (isInvoiceEmpPending) {
      updateEmployee();
    }
    const params = {
      amount: values[`amount${invoice.invoiceId}`],
      comment: values[`comment${invoice.invoiceId}`],
      date: values[`date${invoice.invoiceId}`],
      utrNumber: values[`UTRNumber${invoice.invoiceId}`],
      stage: status,
      invoiceId: invoice?.invoiceId,
    };
    setLoading(true);
    API_SERVICE.updateInvoice(params)
      .then(({ data }) => {
        setShowDetail(false);
        callbackUpdateInvoice();
        if (status == "APPROVED") {
          notification.success({ message: data?.payload?.message })
        }
      })
      .catch((e: any) =>
        notification.error({ message: API_SERVICE.handleErrors(e) })
      )
      .finally(() => setLoading(false));
  };

  const updateEmployee = () => {
    const params = {
      "entityDetailsList": employeeDetails?.filter((item: any) => Object.keys(item ?? {}).length > 0),
      "invoiceId": invoice?.invoiceId
    };
    setLoading(true);
    API_SERVICE.addEmployeeToInvoice(params)
      .then(() => {
        const tmp = employeeDetails?.map((item: any) => {
          return { ...item, saved: Object.keys(item ?? {}).length > 0 }
        })
        setEmployeeDetails(tmp);
        dispatch(setIsInvoiceEmpPending(false));
      })
      .catch((e: any) =>
        notification.error({ message: API_SERVICE.handleErrors(e) })
      )
      .finally(() => setLoading(false));
  };

  const renderColumn = (data) => {
    if (data?.render) {
      return data.render(invoice, callback, status);
    }
    if (data?.type == "checkbox") {
      return (
        <Checkbox
          checked={checked}
          onChange={(e: any) => {
            if (e.target.checked) {
              setSelectedInvoices([...selectedInvoices, invoice?.invoiceId]);
            } else {
              setSelectedInvoices(
                selectedInvoices?.filter(
                  (item: any) => item != invoice?.invoiceId
                )
              );
            }
          }}
        />
      );
    }
    let value: any = "";
    if (Array.isArray(data?.dataIndex)) {
      value = invoice;
      data?.dataIndex?.map((item: any) => {
        value = value?.[`${item}`];
      });
    } else {
      value = invoice[`${data.dataIndex}`];
    }
    if (data?.showTooltip) {
      return (
        <Tooltip title={value}>
          <span style={{ textOverflow: "ellipsis", overflow: "hidden" }}>
            {value}
          </span>
        </Tooltip>
      );
    }
    if (data.isAmount) {
      return `Rs. ${numberWithCommas(value)}`;
    }
    return value;
  };

  const disableDate = (current) => {
    return current && current > new Date();
  };

  const renderDetails = () => {
    return (
      <Form
        name={`formInvoice${invoice.invoiceId}`}
        form={formInvoiceRow}
        className="payout-invoices-row-details"
        onFinish={() => setShowEmployeeWarningModal(true)}
      >
        {status == "APPROVED" && (
          <>
            <Form.Item
              name={`date${invoice.invoiceId}`}
              rules={[
                {
                  required: true,
                  message: `Please select Date`,
                },
              ]}
            >
              <DatePicker
                className="custom-input"
                size="large"
                placeholder="Date*"
                disabledDate={disableDate}
              />
            </Form.Item>
            <Form.Item
              name={`amount${invoice.invoiceId}`}
              rules={[
                {
                  required: true,
                  message: `Please enter Amount`,
                },
                () => ({
                  validator(_, value) {
                    if (value == 0) {
                      return Promise.reject(
                        "Please enter valid amount"
                      );
                    }
                    if (isNaN(value)) {
                      return Promise.reject(
                        "Please enter valid amount"
                      );
                    }
                    // const totalEmp = employeeDetails.reduce((sum, item) => sum + Number(item?.payoutAmount ?? 0), 0);
                    // const availbleAmount = invoice.netPayableAmount - totalEmp;
                    const availbleAmount = invoice.netPayableAmount;
                    if (value > availbleAmount) {
                      return Promise.reject(
                        `Please enter less amount than ${availbleAmount}`
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <InputNumber
                className="custom-input-number"
                formatter={(value) => numberWithCommas(value)}
                placeholder="Amount*"
              />
            </Form.Item>
            <FormInput
              name={`UTRNumber${invoice.invoiceId}`}
              placeholder="UTR Number"
              removeDefaultCss
            />
          </>
        )}
        <FormInput
          name={`comment${invoice.invoiceId}`}
          placeholder={"Comment" + (status != "APPROVED" ? "*" : "")}
          removeDefaultCss
          isRequired={status != "APPROVED"}
          requiredLabel="Comment"
        />
        <div style={{ display: "flex", alignItems: "center" }}>
          <Button
            className="border-icon"
            htmlType="submit"
            style={{ "--bgColor": appColors?.appPrimaryColor ?? "" } as any}
            size="small"
            type="text"
            onClick={() => { }}
            icon={<IconSave />}
          />
          <Button
            className="border-icon"
            style={
              {
                "--bgColor": appColors?.appSecondaryColor ?? "#C71C8E",
                "--width": "23px",
              } as any
            }
            size="small"
            type="text"
            onClick={() => {
              setShowDetail(false);
              setStatus(null);
            }}
            icon={<IconRemove />}
          />
        </div>
      </Form>
    );
  };

  const renderEmployee = () => {
    return <Form
      form={formEmployee}
      name={`formEmp${invoice.invoiceId}`}
      // className="payout-invoices-row-details"
      onFinish={() => { updateEmployee() }}
    >
      {employeeDetails.map((employee: any, index: number) => (
        <div
          className="payout-invoices-row-details">
          <Form.Item
            name={`userName${index}`}
            style={{ width: "200px" }}
            rules={[
              {
                required: true,
                message: "Please select Employee",
              },
            ]}
          >
            <AutoComplete
              className={"custom-auto-compleat" + (employee.saved ? " emp-saved" : "")}
              onSearch={debounce(searchAssignTo, 1000)}
              placeholder="Search Employee"
              dropdownClassName="custom-option-list"
              onSelect={(item, opt) => {
                const tmp = [...employeeDetails];
                if (employeeDetails.length > index) {
                  tmp[index] = {
                    ...tmp[index],
                    userId: opt.userId,
                    userName: opt.value,
                    saved: false
                  };
                } else {
                  tmp.push({ userId: opt.userId, userName: opt.value });
                }
                setEmployeeDetails(tmp);
                dispatch(setIsInvoiceEmpPending(true));
              }}
            >
              {assignToData
                .filter((item: any) => !employeeDetails.some((e: any) => e?.userId === (item?.userId ?? item?.id)))
                .map((item: any) => (
                  <Select.Option
                    key={item.id}
                    {...item}
                    value={item.fullName}
                    style={{ paddingBlock: "0px" }}
                  >
                    <div>
                      <span style={{ fontSize: '12px' }}>{item.fullName}</span>
                      <div style={{ display: "flex", justifyContent: 'space-between' }}>
                        <span style={{ fontSize: '10px', color: "gray" }}>
                          {item?.address?.city && item?.address?.city}
                        </span>
                        <span style={{ fontSize: '10px', color: "gray" }}>
                          {item?.phoneNumber && item?.phoneNumber}
                        </span>
                      </div>
                    </div>
                  </Select.Option>
                ))}
            </AutoComplete>
          </Form.Item>
          <Form.Item
            name={`amount${index}`}
            rules={[
              () => ({
                validator(_, value) {
                  if (value == 0) {
                    return Promise.reject(
                      "Please enter valid amount"
                    );
                  }
                  if (isNaN(value)) {
                    return Promise.reject(
                      "Please enter valid amount"
                    );
                  }
                  // const allValues = formInvoiceRow.getFieldValue(`amount${invoice.invoiceId}`)
                  // const totalEmp = employeeDetails?.filter((item: any, i: number) => i != index)
                  //   .reduce((sum, item) => sum + Number(item?.payoutAmount ?? 0), 0);
                  // const availbleAmount = invoice.netPayableAmount - Number(allValues ?? 0) - totalEmp;
                  // if (value > availbleAmount) {
                  //   return Promise.reject(
                  //     `Please enter less amount than ${availbleAmount}`
                  //   );
                  // }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <InputNumber
              className={"custom-input-number" + (employee.saved ? " emp-saved" : "")}
              formatter={(value) => numberWithCommas(value)}
              onClick={() => {
                const tmp = [...employeeDetails];
                if (employeeDetails.length > index) {
                  tmp[index] = {
                    ...tmp[index],
                    saved: false
                  };
                }
                setEmployeeDetails(tmp);
              }}
              onBlur={(e) => {
                const tmp = [...employeeDetails];
                if (employeeDetails.length > index) {
                  tmp[index] = {
                    ...tmp[index],
                    payoutAmount: formEmployee.getFieldValue(`amount${index}`),
                    saved: false
                  };
                } else {
                  tmp.push({ payoutAmount: formEmployee.getFieldValue(`amount${index}`) });
                }
                setEmployeeDetails(tmp);
                dispatch(setIsInvoiceEmpPending(true));
              }}
              placeholder="Amount*"
            />
          </Form.Item>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              className="border-icon"
              style={
                {
                  "--bgColor": appColors?.appSecondaryColor ?? "#C71C8E",
                  "--width": "23px",
                } as any
              }
              size="small"
              type="text"
              onClick={() => {
                const tmp = [...employeeDetails];
                tmp.splice(index, 1);
                setEmployeeDetails(tmp);
                setEmployeeFields(tmp);
                dispatch(setIsInvoiceEmpPending(true));
              }}
              icon={<IconRemove />}
            />
            {index == 0 &&
              <Tooltip title="Add new employee">

                <Button
                  className="border-icon"
                  style={
                    {
                      "--bgColor": appColors?.appPrimaryColor ?? "",
                      "--width": "25px",
                    } as any
                  }
                  size="small"
                  type="text"
                  onClick={() => {
                    const last = employeeDetails.at(-1)
                    if (((last?.userName?.length ?? 0) > 0 &&
                      (last?.payoutAmount?.toString()?.length ?? 0) > 0)) {
                      const tmp = [...employeeDetails];
                      tmp.push({});
                      setEmployeeDetails(tmp);
                    }
                  }}
                  icon={<IconAdd />}
                />
              </Tooltip>
            }
            {index == 0 &&
              <Button
                className="border-icon"
                htmlType="submit"
                style={{ "--bgColor": appColors?.appPrimaryColor ?? "" } as any}
                size="small"
                type="text"
                onClick={() => { }}
                icon={<IconSave />}
              />
            }
          </div>
        </div>
      ))}

    </Form>
  }

  const modalEmployeePayout = () => {
    return (
      <Modal
        title="Employee Payout"
        centered
        width={400}
        visible={showEmployeePayoutModal}
        closable={false}
        wrapClassName="my-custom-modal"
        footer={[
          <Button
            key="ok"
            type="primary"
            onClick={() => setShowEmployeePayoutModal(false)}
            style={{ "--bgColor": appColors?.appPrimaryColor ?? "", width: "100px" } as any}
          >
            OK
          </Button>
        ]}
      >
        <div style={{ padding: "20px 40px", textAlign: "center" }}>
          Please add employee/s with payout amounts if required.
        </div>
      </Modal>
    );
  }

  const modalEmployeeWarning = () => {
    return (
      <Modal
        title={false}
        centered
        width={380}
        visible={showEmployeeWarningModal}
        closable={false}
        wrapClassName="my-custom-modal"
        footer={[
          <Button
            key="ok"
            type="primary"
            onClick={() => {
              setShowEmployeeWarningModal(false)
              const allValues = formInvoiceRow.getFieldsValue()
              updateInvoice(allValues);
            }}
            style={{ "--bgColor": appColors?.appPrimaryColor ?? "", width: "100px" } as any}
          >
            OK
          </Button>,
          <Button
            key="ok"
            type="default"
            className="app-btn-border"
            onClick={() => setShowEmployeeWarningModal(false)}
            style={{ "--btnColor": appColors?.appSecondaryColor ?? "", width: "100px", display: "inline" } as any}
          >
            Cancel
          </Button>
        ]}
      >
        <div style={{ padding: "20px 40px", textAlign: "center" }}>
          Are you sure you want to continue?
          This action cannot be reversed.
          Click cancel to edit/confirm employee details.
        </div>
      </Modal>
    );
  }

  return (
    <>
      <div className="payout-invoices-row">
        {columns?.map((data: any, index) => {
          let styleExtra: any = {};
          if (data?.fixed == "right") {
            let right = 0;
            if (columns.length - 1 != index) {
              for (let i = index + 1; i < columns.length; i++) {
                right = right + (columns.at(i)?.width ?? 120);
              }
            }
            let sty = {};
            if (columns.at(index - 1)?.fixed !== "right") {
              sty = { borderLeft: "1px solid #DFE0EB" };
            }
            styleExtra = {
              position: "sticky",
              right: right,
              zIndex: 5,
              ...sty,
            };
          }
          return (
            <div
              style={{
                width: data?.width ?? "120px",
                ...styleExtra,
              }}
              className={"payout-invoices-col " + (data?.className ?? "")}
            >
              {renderColumn(data)}
            </div>
          );
        })}
      </div>
      {showDetail && renderDetails()}
      {status == "APPROVED" && renderEmployee()}
      {loading && <AppLoading />}
      {showEmployeePayoutModal && modalEmployeePayout()}
      {showEmployeeWarningModal && modalEmployeeWarning()}
    </>
  );
};

export default PayoutInvoicesRow;
